<template>
  <div class='container container-nav pl20 pr20'>
    <van-nav-bar
      :title="id ? '详情' : '新增'"
      left-arrow
      right-text="按钮"
      @click-left="goBack()"
      @click-right="delItem()"
      :fixed="true">
      <template #right>
        <van-icon name="delete-o" size="18" />
      </template>
    </van-nav-bar>
    <div class="content-box">
      <p><span>养旺记忆</span></p>
      <div class="content">{{detail.content}}</div>
    </div>
    <div class="img-list file-img" v-if="detail.files && detail.files.length">
      <img @click="previewImg(detail.files.map(img => img.file_path), index)" v-for="(item, index) in detail.files" :key="index" :src="item.file_path" alt="">
    </div>
    <div v-if="detail.cases && detail.cases.length">
      <div class="case-title">
        <span class="title">病例报告</span>
        <!-- <van-button @click="getAIReport()" class="case-btn" type="primary" size="mini">AI解读</van-button> -->
      </div>
      <div class="img-list case-img">
        <img @click="previewImg(detail.cases.map(img => img.file_path), index)" v-for="(item, index) in detail.cases" :key="index" :src="item.file_path" alt="">
      </div>
    </div>
    <div class="ml16" v-if="detail.other && detail.other.length">
      <p class="f16 c-999">其他资料({{detail.other.length}}/3)</p>
      <div class="file-list">
        <div class="file-item" v-for="(item, index) in detail.other" :key="index">
          <div class="icon">
            <van-icon name="description-o" />
          </div>
          <div class="detail">
            <p class="name">{{item.origin_name}}</p>
            <p class="desc"><span>{{item.size | FileSize}}</span><span class="type txt-elips">{{item.mime_type}}</span></p>
          </div>
          <div>
            <van-popover
              v-model="item.showPop"
              theme="dark"
              placement="left"
              trigger="click"
              :actions="actions(item)"
              @select="downloadFile(item, index)"
            >
              <template #reference>
                <van-icon name="ellipsis" style="transform: rotate(90deg)" size="20" />
              </template>
            </van-popover>
          </div>
        </div>
      </div>
    </div>
    <van-popup v-model="show" class="report-box" get-container="body" round :overlay="false" :close-on-popstate="true" :close-on-click-overlay="false">
      <div class="pos-r">
        <van-icon name="cross" size="22" class="item-del" @click="close()"/>
        <div class="loading" v-show="!report">
          <van-loading size="60" type="spinner" color="#07c160"/>
          <p class="pt10" style="color: #07c160;">报告解读中请稍后...</p>
        </div>
        <div v-show="report">
          <p class="title">报告解读</p>
          <div id="ToHtml" class="report" v-html="markdownToHtml(report)"></div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import markdownIt from 'markdown-it';
let markd = '';
export default {
  name: 'ywq-detail',
  data() {
    return {
      show: false,
      report: '',
      loading: false,
      detail: {
        content: '',
        files: [],
        cases: [],
        other: []
      }
    };
  },
  filters: {
    FileSize: function (value) {
      if (!value) {
        return '0 Bytes';
      }
      const units = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      let i = 0;
      while (value >= 1024) {
        value /= 1024;
        i++;
      }
      return value.toFixed(2) + ' ' + units[i];
    }
  },
  computed: {
    id() {
      return this.$route.query.id || '';
    }
  },
  beforeMount() {
    markd = markdownIt({
      html: true,
      xhtmlOut: true,
      linkify: false,
      tyographer: false
    });
    this.getDetail();
  },
  beforeDestroy() {
    markd = undefined;
  },
  methods: {
    markdownToHtml(value) {
      return markd.render(value);
    },
    async getAIReport() {
      try {
        const that = this;
        this.show = true;
        this.report = '';
        // 模拟对话
        const data = {
          // eslint-disable-next-line
          data_encrypt: this.id
        };
        this.loading = true;
        this.$store.dispatch('chatStore/sendMessage', {
          url: '/api/http/feed/analyze',
          data: data,
          onMessage(sseMessage) {
            if (sseMessage.choices && sseMessage.choices[0].delta.content) {
              const newContent = sseMessage.choices[0].delta.content;
              that.report += newContent;
            }
          },
          onError(error) {
            that.loading = false;
            that.report = 'AI解读失败: ' + error.message;
            that.ToastUni('AI解读失败: ' + error.message);
            console.log('onError:', error);
          },
          onComplete() {
            that.$nextTick(() => {
              const div = document.getElementById('ToHtml');
              if (div) {
                const domList = Array.from(div.getElementsByTagName('table'));
                domList.forEach(item => {
                  const newParent = document.createElement('div');
                  newParent.className = 'tableDiv';
                  item.parentNode.insertBefore(newParent, item.nextElementSibling);
                  newParent.appendChild(item);
                });
                that.loading = false;
              }
            });
          }
        });
      } catch (error) {
        // console.log(error);
        // todo
      }
    },
    async close() {
      if (!this.loading) {
        this.show = false;
      } else {
        this.Dialog({
          title: '提示',
          message: '报告正在解读中，取消不返还所消耗次数，确认要取消吗？'
        })
          .then(() => {
            this.show = false;
            this.$nextTick(() => {
              this.report = '';
            });
          })
          .catch(() => {
            // todo
          });
      }
    },
    actions(item) {
      return [{ text: '下载' }];
    },
    downloadFile(item, index) {
      console.log(item, index);
      this.download({
        url: item.file_path,
        name: item.origin_name,
        error: 'downErr'
      });
    },
    async getDetail() {
      try {
        const res = await this.$store.dispatch('getData', {
          url: '/api/http/feed/info?data_encrypt=' + this.id
        });
        if (res.other) {
          res.other.map(i => {
            i.showPop = false;
          });
        }
        this.detail = res;
      } catch (error) {
        this.ToastUni(error.message);
      }
    },
    async delItem() {
      this.Dialog({
        title: '确认删除？',
        message: ''
      })
        .then(async () => {
          try {
            await this.$store.dispatch('postData', {
              url: '/api/http/feed/remove',
              data: {
                // eslint-disable-next-line
                data_encrypt: this.id
              }
            });
            window.upDateDetail = {
              type: 'delect',
              id: this.id
            };
            this.ToastUni('删除成功');
            this.laterGoBack();
          } catch (error) {
            this.ToastUni(error.message);
          }
        })
        .catch(() => {
          // todo
        });
    }
  }
};
</script>
<style lang='less' scoped>
.container /deep/ .van-cell__title span{
  font-weight: 800;
}
.content-box{
  padding-top: 20px;
  p{
    font-weight: 800;
    font-size: 14px;
    padding: 10px 16px;
  }
}
.content{
  color: #323233;
  padding: 0 16px;
  font-size: 14px;
  min-height: 100px;
  padding-bottom: 10px;
}
.content-box{
  position: relative;
}
.img-list{
  position: relative;
  padding: 16px;
  display: flex;
  flex-wrap: wrap;
  img{
    width: 20vw;
    height: 20vw;
    object-fit: cover;
    margin: 0 8px 8px 0;
  }
}
.file-img::after{
  content: '';
  position: absolute;
  top: 2px;
  left: 16px;
  width: calc(100% - 32px);
  height: 2px;
  background-color: #eee;
}
.case-title{
  padding: 6px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .title{
    font-weight: 800;
    font-size: 14px;
    line-height: 24px;
  }
  .case-btn{
    width: 70px;
    text-align: center;
  }
}
.case-img::after{
  content: '';
  position: absolute;
  top: 2px;
  left: 16px;
  width: calc(100% - 32px);
  height: 2px;
  background-color: #eee;
}
.report-box{
  width: 80vw;
  max-height: 80vh;
  overflow-y: auto;
  box-sizing: border-box;
  padding: 10px 12px;
  box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.3);
  background-color: #eee;
  .item-del{
    box-sizing: border-box;
    position: absolute;
    top: -5px;
    right: -5px;
    width: 29px;
    height: 29px;
    padding: 3px;
    font-size: 14px;
    color: #ccc;
    background-color: #fff;
    border-radius: 50%;
    border: 1px solid #ccc;
  }
  .loading{
    width: 100%;
    height: 140px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  p{
    font-size: 18px;
  }
  .title{
    font-size: 22px;
    line-height: 30px;
    font-weight: 600;
    width: 100%;
    text-align: center;
    color: #07c160;
  }
}
.report{
  font-size: 16px;
  margin: 10px 0;
  max-height: calc(80vh - 70px);
  min-height: 300px;
  overflow-y: auto;
}
.report /deep/ .tableDiv{
  width: calc(100vw - 130px);
  padding: 10px 0;
  // width: 100%;
  overflow-x: auto;
  table{
    min-width: 100%;
    width: max-content;
    border: 1px solid #333;
    border-radius: 5px;
    th{
      padding: 2px 4px;
    }
    th+th{
      border-left: 1px solid #333;
    }
    td{
      padding: 2px 4px;
    }
    td+td{
      border-left: 1px solid #333;
    }
  }
}
.file-list{
  padding: 10px 0;
  .file-item{
    margin: 10px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    .icon{
      width: 45px;
      height: 45px;
      color: #fff;
      background-color: #E7C188;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .detail{
      height: 45px;
      width: calc(100% - 75px);
      padding: 5px 0;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      align-items: stretch;
      .name{
        font-size: 14px;
        font-weight: 600;
      }
      .desc{
        color: #999;
        font-size: 12px;
        display: flex;
        justify-content: space-between;
        .type{
          max-width: calc(100vw - 200px);
        }
      }
    }
  }
}
.del{
  position: absolute;
  top: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
